import { en } from "./en.js";
import { bn } from "./bn.js";
export const dictionaries = { en, bn };
/**
 * Returns the dictionary for a locale. Components read strings as plain
 * property access (`t.common.retry`) — typed, tree-shakeable, ~zero runtime.
 */
export function getDictionary(locale) {
    return dictionaries[locale];
}
//# sourceMappingURL=index.js.map